const FIREBASE_SUBDOMAIN = 'zippertic';
const ANDROID_PACKAGE_NAME = 'com.codiqo.zippertic';
const IOS_BUNDLE_ID = '1544944884';
const IOS_PREFIX = 'zippertic';
const IOS_PACKAGE_NAME = 'com.codiqo.zippertic';

export default link => {
    return `https://${FIREBASE_SUBDOMAIN}.page.link/?link=${encodeURIComponent(link)}&apn=${ANDROID_PACKAGE_NAME}&isi=${IOS_BUNDLE_ID}&ius=${IOS_PREFIX}&ibi=${IOS_PACKAGE_NAME}`;
}